import React, { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

const formatDate = (ts) => {
  if (!ts) return '';
  const d = ts.toDate ? ts.toDate() : new Date(ts.seconds ? ts.seconds * 1000 : ts);
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

// Public credential verification page. Anyone with the link can view it,
// no login required. Reached via #/verify/{credentialId}.
export default function VerifyCertificate({ certId }) {
  const [record, setRecord] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'certVerifications', certId));
        if (snap.exists()) {
          setRecord(snap.data());
          setState('found');
        } else {
          setState('notfound');
        }
      } catch {
        setState('notfound');
      }
    };
    if (certId) load(); else setState('notfound');
  }, [certId]);

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.topBar}>
          <span style={s.org}>The Corporate <span style={{ color: '#E87166' }}>Fixers</span></span>
        </div>

        {state === 'loading' && (
          <div style={s.body}><p style={s.muted}>Checking credential…</p></div>
        )}

        {state === 'notfound' && (
          <div style={s.body}>
            <div style={s.eyebrow}>Credential Verification</div>
            <p style={s.notFoundTitle}>We could not verify this credential.</p>
            <p style={s.muted}>
              The credential ID in this link does not match our records. Check that the link was
              copied completely, or contact us at thecorporatefixers.com.
            </p>
          </div>
        )}

        {state === 'found' && record && (
          <div style={s.body}>
            <div style={s.validPill}>✓ Verified credential</div>
            <div style={s.eyebrow}>{record.credentialTitle || 'Certified AI Practitioner'}</div>
            <p style={s.awardedTo}>Awarded to</p>
            <p style={s.name}>{record.participantName}</p>
            <p style={s.program}>
              for successful completion of all program requirements for<br />
              <em>{record.programName}</em>
            </p>
            <div style={s.metaRow}>
              <div style={s.metaBlock}>
                <div style={s.metaLabel}>Date of completion</div>
                <div style={s.metaValue}>{formatDate(record.completedAt)}</div>
              </div>
              <div style={s.metaBlock}>
                <div style={s.metaLabel}>Credential ID</div>
                <div style={s.metaValue}>{record.credentialId || certId}</div>
              </div>
            </div>
            <p style={s.issuer}>
              Issued by The Corporate Fixers · From Curious to Capable, the hands-on AI
              training program for the modern workforce.
            </p>
          </div>
        )}

        <div style={s.footer}>
          <a href="https://www.thecorporatefixers.com" style={s.footerLink} target="_blank" rel="noopener noreferrer">thecorporatefixers.com</a>
        </div>
      </div>
    </div>
  );
}

const N = '#1B2A4A';
const G = '#C9A84C';
const s = {
  page: { minHeight: '100vh', background: '#F2F0EC', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: 'DM Sans, sans-serif' },
  card: { background: '#FFFFFF', border: `3px solid ${N}`, maxWidth: '560px', width: '100%' },
  topBar: { background: N, padding: '16px 28px', borderBottom: `3px solid ${G}` },
  org: { fontFamily: 'Playfair Display, serif', fontSize: '18px', fontWeight: '700', color: '#FFFFFF' },
  body: { padding: '32px 36px', textAlign: 'center' },
  validPill: { display: 'inline-block', background: '#eaf3de', color: '#3b6d11', fontSize: '12px', fontWeight: '700', padding: '6px 16px', borderRadius: '20px', marginBottom: '18px' },
  eyebrow: { fontFamily: 'Playfair Display, serif', fontSize: '24px', fontWeight: '900', color: N, letterSpacing: '0.5px', marginBottom: '14px' },
  awardedTo: { fontSize: '10px', color: '#8A8A8A', letterSpacing: '3px', textTransform: 'uppercase', margin: '10px 0 4px' },
  name: { fontFamily: 'Playfair Display, serif', fontSize: '30px', fontStyle: 'italic', color: N, margin: '0 0 14px', lineHeight: 1.2 },
  program: { fontSize: '13px', color: '#555', lineHeight: 1.7, margin: '0 0 22px' },
  metaRow: { display: 'flex', justifyContent: 'center', gap: '40px', flexWrap: 'wrap', borderTop: '1px solid #E8E6E2', paddingTop: '18px', marginBottom: '18px' },
  metaBlock: { textAlign: 'center' },
  metaLabel: { fontSize: '9px', color: '#8A8A8A', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '4px' },
  metaValue: { fontSize: '14px', color: N, fontWeight: '600' },
  issuer: { fontSize: '11.5px', color: '#8A8A8A', lineHeight: 1.6, margin: 0 },
  notFoundTitle: { fontFamily: 'Playfair Display, serif', fontSize: '20px', color: N, margin: '10px 0' },
  muted: { fontSize: '13px', color: '#8A8A8A', lineHeight: 1.6 },
  footer: { background: '#F2F0EC', padding: '12px 28px', textAlign: 'center', borderTop: '1px solid #E8E6E2' },
  footerLink: { fontSize: '12px', color: N, fontWeight: '600', textDecoration: 'none' },
};
